import * as React from "react";
import { Route, Switch } from "react-router-dom";

import Nav from "../../_layout/nav/Nav";

import Users from "../users/Users";
import Categories from "../categories/Categories";
import Campaigns from "../campaigns/Campaigns";
import Campaign from "../campaign/Campaign";
import CampaignUsers from "../campaign/Users";
import Clients from "../clients/Clients";

export default class Home extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      menuOpened: false
    }
  }
  componentWillMount() {
    let account = JSON.parse(window.localStorage.getItem("account") || "{}");
    if (!(account && account.token)) {
      this.props.history.push("/login");
    } else {
      window.account = account;
    }
  }

  openMenu = () => {
    this.setState({ menuOpened: true });
  }

  closeMenu = () => {
    this.setState({ menuOpened: false });
  }

  public render() {
    return (
      <div id="router-root">
        <Nav history={this.props.history} menuOpened={this.state.menuOpened} closeMenu={this.closeMenu} />
        <div className="innerWindow">
          <Switch>
            <Route
              path={`/categories`}
              render={(props: any) => (
                <Categories {...props} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/clients`}
              render={(props: any) => (
                <Clients {...props} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/campaigns/:id/users/:userId`}
              render={(props: any) => (
                <Campaign {...props} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/campaigns/:id/users`}
              render={(props: any) => (
                <CampaignUsers {...props} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/campaigns/:id`}
              render={(props: any) => (
                <Campaign {...props} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/campaigns`}
              render={(props: any) => (
                <Campaigns {...props} openMenu={this.openMenu} />
              )}
            />

            <Route
              path={`/users`}
              render={(props: any) => (
                <Users {...props} international={false} openMenu={this.openMenu} />
              )}
            />
            <Route
              path={`/international-users`}
              render={(props: any) => <Users {...props} international={true} openMenu={this.openMenu} />}
            />
            <Route
              path={`/`}
              exact
              render={(props: any) => (
                <Campaigns {...props} openMenu={this.openMenu} />
              )}
            />
          </Switch>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/Home.tsx